import { Injectable } from '@angular/core';
import { VacationSearchContent } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  Dates,
  VacationSearchInput
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  ADULTS_PLURAL_TEXT,
  ADULTS_SINGULAR_TEXT,
  CHILD_PLURAL_TEXT,
  CHILD_SINGULAR_TEXT,
  MODIFY_BUTTON,
  ROOM_PLURAL_TEXT,
  ROOM_SINGULAR_TEXT
} from '../../constants/header-slim/header-slim.constants';
import { NavSlimVacationParseData } from '../../models/interface/vacation-header/vacation-header.interfaces';
import { getDateFormat } from '../../utils/header-slim/sanitization.utils';
import { formatLabel } from '../../utils/vacation-header/vacation-header.utils';

@Injectable({ providedIn: 'root' })
export class VacationHeaderAdapter {
  transformFromInput(input: VacationSearchInput): NavSlimVacationParseData {
    return {
      origin: input.origin ?? '',
      destination: input.destination,
      dates: this.formatDates(input.dates),
      rooms:
        input.rooms != null
          ? formatLabel(input.rooms, ROOM_SINGULAR_TEXT, ROOM_PLURAL_TEXT)
          : '',
      adults: formatLabel(
        input.adults,
        ADULTS_SINGULAR_TEXT,
        ADULTS_PLURAL_TEXT
      ),
      children:
        input.children != null
          ? formatLabel(input.children, CHILD_SINGULAR_TEXT, CHILD_PLURAL_TEXT)
          : ''
    };
  }

  toVacationSearchContent(
    data: NavSlimVacationParseData
  ): VacationSearchContent {
    const passenger = [data.rooms, data.adults, data.children]
      .filter(Boolean)
      .join(', ');
    return {
      origin: data.origin,
      destination: data.destination,
      dates: data.dates,
      passenger,
      modifyButton: MODIFY_BUTTON
    };
  }

  private formatDates(dates: Dates): string {
    const departure = getDateFormat(dates.departureDate);
    if (!dates.returnDate) return departure;
    const returnFormatted = getDateFormat(dates.returnDate);
    const [depMonth] = departure.split(' ');
    const [, retDay] = returnFormatted.split(' ');
    return depMonth === returnFormatted.split(' ')[0]
      ? `${departure} - ${retDay}`
      : `${departure} - ${returnFormatted}`;
  }
}
